<template>
  <div class="container">
    <div class="panel panel-default">
      <div v-show="loading">
      <h3>Now loading...
      <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
      </h3>
    </div>
    <div v-show="!loading" >
      <div class="panel-body">
        <h2>確認・編集</h2>
        <form
            id="form02"
            name
            action="https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/service/content/send"
            method="post"
            @submit.prevent="address"
          >
          <div class="form-group">
            <p>
              <label for="form_1" class="control-label">メールの件名</label>
              <br>
              <input
                  type="text"
                  v-model="mymailTitle"
                  id="mymailTitle"
                  name="mymailTitle"
                  class="form-control"
                  required
                >
              </p>
              <p>
                <label for="form_1" class="control-label">メール本文</label>
                <br>
                <textarea
                  class="form-control"
                  v-model="destination"
                  id="destination"
                  name="destination"
                  cols
                  rows="2"
                  readonly
                ></textarea>
                <textarea
                  class="form-control"
                  v-model="mymailBody"
                  id="mailBody"
                  name="mailBody"
                  cols
                  rows="30"
                ></textarea>
                <textarea
                  class="form-control"
                  v-model="reply"
                  id="reply"
                  name="reply"
                  cols
                  rows="4"
                  readonly
                ></textarea>
              </p>
              <input type="hidden" name="userId" v-model="userId">
            </div>
            <p align="right">
             <router-link
                id="button_style"
                class="btn btn-outline-secondary"
                to="/Form"
              >戻る</router-link>
              <button class="btn btn-outline-secondary" type="submit">宛先選択</button>
            </p>
          </form>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/store.js'

export default {
  data: function() {
    return {
      mymailTitle: '',
      mail:'',
      destination:'',
      mymailBody: '',
      reply:'',
      cmail:'',
      userId:'',
      loading: true
    }
  },
  created(to, from, next) {
    let self = this
      self.userId =  store.state.userId
  },
  beforeCreate(to, from, next) {
    let self = this
    //console.log(sessionStorage.getItem('Authorization'))
    axios({
      method: 'post',
      url: 'https://a6ecsge4pk.execute-api.ap-northeast-1.amazonaws.com/RECRUITMENT_SEND/service/content/edit',
      data:{
          mailTitle: store.state.mailTitle,
          item: store.state.item,
          itemSummary: store.state.itemSummary,
          period: store.state.period,
          place: store.state.place,
          price: store.state.price,
          skill: store.state.skill,
          note: store.state.note
      },
      headers:{"Authorization":sessionStorage.getItem('Authorization')}
    })
      .then(function(response) {
        console.log(response.data)
        self.mymailTitle = response.data.mailTitle
        self.mail = response.data.mailBody
        self.destination = self.mail.slice(0,29)
        self.mymailBody = self.mail.slice(31,-26)
        self.reply = self.mail.slice(-26)
        self.loading = false
      })
      .catch(function(error) {
        console.log(error)
      })
  },

  methods: {
    address () {
      console.log(this.destination)
      console.log(this.mymailBody)
      console.log(this.reply)
      this.cmail =this.destination+this.mymailBody+this.reply
      store.commit('mutationType', {
        mailTitle: this.mymailTitle,
        mailBody: this.cmail,
        userId:this.userId
      })
          this.$router.replace('/Destination')

    }
  }
}
</script>

<style scoped >
h2 {
  text-align: center;
}
h3 {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Confirmation.vue